module.exports = __webpack_public_path__ + "static/media/studio-pro-step1@3x.0683e2e5.webp";